<template>
    <rkm-layout-body title="Lista de supervisor">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-supervisor-create' })"
                authorize="store-cadastro-supervisor"
                color="primary"
            >
                Cadastrar supervisor
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/cadastro/supervisor/List'

export default {
    components: {List},
}
</script>